import MediumPriority from './MediumPriority';

export default MediumPriority;
